import { cn } from '@/lib/utils'

/**
 * Dorahart brand assets — the interlocking-"D" architectural monogram, taken
 * from the dorahart.com marketing site. `fill-current` so the colour is driven
 * by the surrounding `text-*` class (charcoal / gold / cream).
 */
export function DorahartMonogram({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 -0.03 317.94 402.3"
      aria-hidden="true"
      className={cn('h-full w-auto fill-current', className)}
    >
      <path d="M317.94 243.3v-84.33c0-87.66-63.16-159-140.8-159H0v402.3h177.14c77.64 0 140.8-71.31 140.8-158.97Zm-98.64-33.19h-84.33c-5.61 0-11.24.26-16.8.78v-19.51c5.57.51 11.2.78 16.8.78h84.33c32.31 0 63-8.43 89.43-24.4v66.75c-26.39-15.98-57.12-24.4-89.43-24.4Zm89.39-53.2a159.1 159.1 0 0 1-63.38 24.07v-22c0-66.83-16.83-122.8-41.36-146.63 59.18 13.98 103.89 73.35 104.74 144.56Zm-72.59 2.06v23.15c-5.54.54-11.14.83-16.8.83h-84.33c-5.61 0-11.24-.28-16.8-.83v-23.15c0-81.18 27-149.77 59-149.77s58.93 68.59 58.93 149.77ZM13.78 9.22c18.91 0 36.07 24 47 60.41a171.76 171.76 0 0 0-24.12 80.85 138.59 138.59 0 0 1-27.35-27.67V9.22Zm50.36 310.77a164.39 164.39 0 0 1-18.52-74.57 155.56 155.56 0 0 1 27.08-14.2v12.07c0 27.79-3.17 54.09-8.61 76.68Zm8.61-139v40.43c-24.85 9.39-46.89 24.52-63.49 43.47V137.45c16.52 18.94 38.59 34.08 63.44 43.47Zm0-9.88a154.92 154.92 0 0 1-27.13-14.18 164.46 164.46 0 0 1 18.52-74.57c5.44 22.59 8.61 48.89 8.61 76.68Zm-63.49 222V279.48a138.59 138.59 0 0 1 27.35-27.67 171.76 171.76 0 0 0 24.12 80.85c-10.88 36.4-28 60.4-47 60.4Zm27.82 0c26.42-21.74 44.87-79.79 44.87-149.76v-84.38c0-70-18.45-128-44.87-149.77h116.76c-26.42 21.75-44.87 79.8-44.87 149.77v84.33c0 70 18.45 128 44.87 149.76Zm81.14-149.76v-23.21c5.55-.54 11.18-.83 16.8-.83h84.33c5.66 0 11.26.3 16.8.84v23.15c0 81.18-27 149.76-59 149.76s-58.98-68.58-58.98-149.76ZM204 389.98c24.53-23.84 41.36-79.81 41.36-146.63v-22a159.1 159.1 0 0 1 63.38 24.07c-.9 71.15-45.61 130.51-104.79 144.51Z" />
    </svg>
  )
}

/**
 * Lock-up: monogram + "DORAHART" wordmark set in Marcellus with wide tracking.
 * Pass the Marcellus font via the `--font-marcellus` CSS variable on an ancestor.
 */
export function DorahartLockup({
  className,
  monogramClassName,
  wordmarkClassName
}: {
  className?: string
  monogramClassName?: string
  wordmarkClassName?: string
}) {
  return (
    <span className={cn('inline-flex items-center gap-3', className)}>
      <DorahartMonogram className={cn('h-8', monogramClassName)} />
      <span
        className={cn(
          'text-[1.35rem] leading-none tracking-[0.42em] uppercase',
          wordmarkClassName
        )}
        style={{ fontFamily: 'var(--font-marcellus), serif' }}
      >
        Dorahart
      </span>
    </span>
  )
}
